import React from 'react';
import { Lightbulb } from 'lucide-react';
interface InsightBarProps {
  title?: string;
  message: string | React.ReactNode;
  className?: string;
}
export function InsightBar({
  title = 'Inzicht',
  message,
  className = ''
}: InsightBarProps) {
  return <div className={`bg-indigo-50/50 border border-indigo-100 rounded-2xl p-4 flex items-center gap-4 ${className}`} data-id="element-8341">
      <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0" data-id="element-8342">
        <Lightbulb className="w-5 h-5 text-indigo-600" data-id="element-8343" />
      </div>
      <div className="flex-1" data-id="element-8344">
        <h3 className="text-sm font-bold text-indigo-900 mb-1" data-id="element-8345">{title}</h3>
        <div className="text-sm text-indigo-700" data-id="element-8346">{message}</div>
      </div>
    </div>;
}